const muiCardActionsTheme = (theme) => {
  theme.overrides.MuiCardActions = {
    root: {
      padding: '0 20px 5px 20px',
    },
  };
};

export default muiCardActionsTheme;
